import React from 'react';

const SVG = ({ style = {}, color = 'rgb(46, 255, 46)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <text x="30" y="75" fontFamily="Helvetica" fontSize="68" fontWeight="bold" fill={color}>
        ?
      </text>
    </g>
  </svg>
);

export default SVG;
